import API from "api/client";
import { envConfig } from "config";

const { networksAPI } = envConfig;

/**
 * @param name {string}
 * @returns {Promise<{}>}
 */
const createNetwork = (name) => {
  return API.post(`${networksAPI}`, { name }).then((res) => res.data);
};

/**
 * @param uuid {string}
 * @returns {Promise<{}>}
 */
const getNetwork = (uuid) => {
  return API.get(`${networksAPI}${uuid}`).then((res) => res.data);
};

/**
 * @param name {string}
 * @param uuid {string}
 * @returns {Promise<{}>}
 */
const updateNetwork = (name, uuid) => {
  return API.put(`${networksAPI}${uuid}`, { name: name }).then((res) => res.data);
};

export default {
  create: createNetwork,
  get: getNetwork,
  update: updateNetwork,
};
